import Link from 'next/link';
import styles from './Footer.module.scss';
import BackToTop from '@/components/BackToTop';


// X (formerly Twitter) logo
const XIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16" aria-hidden="true"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
);
const FacebookIcon = () => (
  <svg viewBox="0 0 512 512" fill="currentColor" width="16" height="16" aria-hidden="true"><path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"/></svg>
);
const InstagramIcon = () => (
  <svg viewBox="0 0 448 512" fill="currentColor" width="16" height="16" aria-hidden="true"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg>
);
const PinterestIcon = () => (
  <svg viewBox="0 0 384 512" fill="currentColor" width="16" height="16" aria-hidden="true"><path d="M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"/></svg>
);

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className="page-shell">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-4 lg:col-span-1 xl:col-span-1">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src="/assets/images/logos/lovingecards-logo-light.svg" alt="LovingEcards" width={182} height={36} className="mb-4 h-9 w-auto" />
            <p className="text-sm leading-relaxed text-night-link">LovingEcards is an easy online platform for creating free group greeting cards, digital ecards, and invitations. Celebrate birthdays, farewells, thank you notes, weddings, work anniversaries and more with group cards everyone can sign. Make all events memorable today!</p>
          </div>

          {/* Group Card Categories */}
          <div>
            <p className={styles['section-title']}>Group Cards</p>
            <ul className={styles['link-list']}>
              <li><Link href="/categories/birthday-cards">Birthday Cards</Link></li>
              <li><Link href="/categories/farewell-cards">Farewell Cards</Link></li>
              <li><Link href="/categories/wedding-cards">Wedding Cards</Link></li>
              <li><Link href="/categories/thank-you-cards">Thank You Cards</Link></li>
              <li><Link href="/categories">All Categories</Link></li>
              <li><Link href="/group-video-cards">Group Video</Link></li>
              <li><Link href="/bulk-cards">Bulk Cards</Link></li>
            </ul>
          </div>

          {/* Invitation Categories */}
          <div>
            <p className={styles['section-title']}>Invitations</p>
            <ul className={styles['link-list']}>
              <li><Link href="/invitations/birthday">Birthday Invitations</Link></li>
              <li><Link href="/invitations/wedding">Wedding Invitations</Link></li>
              <li><Link href="/invitations/baby-shower">Baby Shower</Link></li>
              <li><Link href="/invitations/anniversary">Anniversary</Link></li>
              <li><Link href="/invitations/dinner-party">Dinner Party</Link></li>
              <li><Link href="/invitations">All Invitations</Link></li>
            </ul>
          </div>

          {/* Use Cases */}
          <div>
            <p className={styles['section-title']}>Solutions</p>
            <ul className={styles['link-list']}>
              <li><Link href="/solutions/enterprise">Enterprise &amp; Industry</Link></li>
              <li><Link href="/solutions/business">Business (SMB)</Link></li>
              <li><Link href="/solutions/department">Departments</Link></li>
              <li><Link href="/solutions/education-community">Education &amp; Community</Link></li>
              <li><Link href="/solutions/hr">Human Resources</Link></li>
              <li><Link href="/solutions/events">Events</Link></li>
            </ul>
          </div>

          {/* pages */}
          <div>
            <p className={styles['section-title']}>Pages</p>
            <ul className={styles['link-list']}>
              <li><Link href="/faq">FAQ</Link></li>
              <li><Link href="/blog">Blog</Link></li>
              <li><Link href="/pricing">Pricing</Link></li>
              <li><Link href="/inspiration-calendar">Inspiration Calendar</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <p className={styles['section-title']}>Company</p>
            <ul className={styles['link-list']}>
              <li><Link href="/about">About Us</Link></li>
              <li><Link href="/contact">Contact</Link></li>
              <li><Link href="/privacy-policy">Privacy Policy</Link></li>
              <li><Link href="/terms-and-conditions">Terms &amp; Conditions</Link></li>
              <li><Link href="/disclaimer">Disclaimer</Link></li>
              <li><Link href="/cookie-policy">Cookie Policy</Link></li>
            </ul>
          </div>

        </div>

        <hr className={styles.divider} />

        <div className="flex flex-col md:flex-row md:justify-between md:items-center">
          <div>
            <p className={styles.copyright}>© {currentYear} LovingEcards. All rights reserved.</p>
          </div>
          <div className="mt-4 md:mt-0">
            <div className={styles['social-links']}>
              <a href="https://x.com/lovingecards" target="_blank" rel="noopener noreferrer" aria-label="LovingEcards on X">
                <XIcon />
              </a>
              <a href="https://www.facebook.com/lovingecards/" target="_blank" rel="noopener noreferrer" aria-label="LovingEcards on Facebook">
                <FacebookIcon />
              </a>
              <a href="https://www.instagram.com/lovingecards/" target="_blank" rel="noopener noreferrer" aria-label="LovingEcards on Instagram">
                <InstagramIcon />
              </a>
              <a href="https://pinterest.com/lovingecards/" target="_blank" rel="noopener noreferrer" aria-label="LovingEcards on Pinterest">
                <PinterestIcon />
              </a>
            </div>
          </div>
        </div>
      </div>
      <BackToTop />
    </footer>
  );
}
